module.exports = __webpack_public_path__ + "static/media/n-genius-mini.3178738e.png";